/**
 * Labstep
 *
 * @module screens/Master/Index/Center
 * @desc Generic Screen for rendering a list of entities with search bar + filters
 */

import EntitySearch from 'labstep-web/components/Entity/Search';
import { EntitySearchContainer as EntitySearchCursor } from 'labstep-web/components/Entity/Search/Cursor';
import { LayoutFullPageError as FullPageError } from 'labstep-web/components/Layout/FullPageError';
import { withUiPersistent } from 'labstep-web/containers/UiPersistent';
import { MediaQueryMobile as Mobile } from 'labstep-web/core/MediaQuery/Mobile';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import styles from './styles.module.scss';
import type {
  IMasterIndexCenterProps,
  IMasterIndexCenterWithHOCProps,
} from './types';

export const MasterIndexCenter: React.FC<
  IMasterIndexCenterWithHOCProps
> = ({
  children,
  leftPane,
  isCursor,
  location,
  initialSearchParams,
  uiPersistent,
  breadcrumb,
  ...rest
}) => {
  const Component: any = isCursor ? EntitySearchCursor : EntitySearch;
  return (
    <div className={styles.container}>
      {breadcrumb && (
        <div className={styles.breadcrumbContainer}>{breadcrumb}</div>
      )}

      <Component
        historyAction="replace"
        errorComponent={<FullPageError />}
        initialSearchParams={
          (uiPersistent.search_params[location.pathname] ||
            initialSearchParams) as any
        }
        {...rest}
      >
        {children}
      </Component>
    </div>
  );
};

export const MasterIndexCenterContainer = withUiPersistent(
  withRouter(MasterIndexCenter),
);

export const MasterIndexCenterMobileContainer: React.FC<
  IMasterIndexCenterProps
> = (props) => (
  <Mobile>
    {({ match }): React.ReactElement => (
      <MasterIndexCenterContainer tableFormat={!match} {...props} />
    )}
  </Mobile>
);
